import { Typography, useTheme } from '@mui/material';
import { FieldTemplate, LayoutItem } from 'api/models';
import { LayoutItemType } from 'api/models/FormTemplate';
import { useDragLayer } from 'react-dnd';
import MuiIcon from 'components/MuiIcon/MuiIcon';
import { t } from 'i18next';
import { getFieldIcon } from './AddFieldButton';

function renderContent(item?: LayoutItem, field?: FieldTemplate) {
  switch (item?.type) {
    case LayoutItemType.Static:
      return (
        <>
          <MuiIcon icon={getFieldIcon(field?.fieldType)} sx={{ ml: 2 }} />
          <Typography fontSize="small" sx={{ p: 1 }}>
            {t('forms.fieldType.divider')}
          </Typography>
        </>
      );
    case LayoutItemType.Container:
      return (
        <>
          <MuiIcon icon={getFieldIcon(field?.fieldType)} sx={{ ml: 2 }} />
          <Typography fontSize="small" sx={{ p: 1 }}>
            {t('forms.fieldType.layout')}
          </Typography>
        </>
      );
    case LayoutItemType.Input:
      return (
        <>
          <MuiIcon
            icon={getFieldIcon(field?.fieldType)}
            sx={{ ml: 2, mr: 1 }}
          />
          <Typography fontSize="small" fontWeight={'bold'}>
            {t('general.type')}:
          </Typography>
          <Typography fontSize="small" sx={{ p: 1 }}>
            {t(`forms.fieldType.${field?.fieldType}`)},
          </Typography>

          <Typography fontSize="small" fontWeight={'bold'}>
            {t('forms.fieldAttributes.label')}:
          </Typography>
          <Typography fontSize="small" sx={{ p: 1 }}>
            {field?.fieldAttributes.label},
          </Typography>

          <Typography fontSize="small" fontWeight={'bold'}>
            {t('forms.fieldAlias')}:
          </Typography>
          <Typography fontSize="small" sx={{ p: 1 }}>
            {field?.alias}
          </Typography>
        </>
      );
    default:
      return null;
  }
}

export default function DragPreview() {
  const { isDragging, item, currentOffset } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));
  const theme = useTheme();

  function renderItem() {
    return (
      <div
        style={{
          position: 'absolute',
          pointerEvents: 'none',
          left: currentOffset?.x,
          top: currentOffset?.y,
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          display: 'flex',
          flexDirection: 'row',
          borderRadius: '10px',
          padding: '20px',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {renderContent(item.layoutItem, item.field)}
      </div>
    );
  }

  if (!isDragging) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        pointerEvents: 'none',
        zIndex: 100,
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
      }}
    >
      {renderItem()}
    </div>
  );
}
